<template>
  <div class="db-100 gift-cart-contents" :id="id">
    <span class="giftCartTitle">{{ t("cart.gifts.list.title") }}</span>
    <div class="d-flex-100 gift-cart-row-in">
      <adv-cart-gift-row-group
        v-for="(cartProductGroup, index) in filteredGiftChoicesByGiftId"
        :key="index"
        :enable-picker="shouldEnablePicker(cartProductGroup.id)"
        :enable-minicart-picker="shouldEnableMinicartPicker(cartProductGroup.id)"
        :mini-cart="miniCart"
        :is-mini-cart-component="isMiniCartComponent"
        :styling-options="stylingOptions"
        :cart-gift-product-group="cartProductGroup"
      ></adv-cart-gift-row-group>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AdvCartGiftRowGroup from './AdvCartGiftRowGroup'
import cartGiftOptionsMixin from './mixins/cartGiftOptionsMixin'
import { each, filter, includes, uniqueId } from 'lodash-es'

export default {
  name: 'AdvCartGiftList',
  components: {
    AdvCartGiftRowGroup
  },
  props: {
    giftChoicesFilter: {
      type: Function,
      required: false,
      default: (giftChoicesGroupedByGiftId) => giftChoicesGroupedByGiftId
    }
  },
  mixins: [cartGiftOptionsMixin],
  data () {
    return {
      id: '',
      version: '0.0.1'
    }
  },
  computed: {
    ...mapGetters(['giftChoicesGroupedByGiftId']),
    filteredGiftChoicesByGiftId () {
      return this.giftChoicesFilter(this.giftChoicesGroupedByGiftId)
    },
    giftSliders () {
      return filter(
        this.conf.get('sliders', 'slick'),
        (slider) => {
          if (!includes(slider.selector, '.slick-checkout-gifts-slider')) { return false }
          return this.jQuery(`#${this.id}`).has(this.jQuery(slider.selector)).length > 0
        }
      )
    }
  },
  methods: {
    updateSliders () {
      each(this.giftSliders, (sliderData) => {
        const $slider = this.jQuery(sliderData.selector)
        $slider.not('.slick-initialized').slick(sliderData.settings)
      })
    }
  },
  mounted () {
    this.id = `gift-list-${uniqueId()}`
    this.$nextTick(() => {
      this.updateSliders()
    })
  }
}
</script>
